module.exports = __webpack_public_path__ + "static/media/buro.5346ed9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buro.jpg
// module id = 1635
// module chunks = 0